// extracted by mini-css-extract-plugin
module.exports = {"List":"GXRnZ","Toggle":"a2BfR","Container":"_3aW7A","Compare":"_1biho","Subheader":"ZzrZq","LegalFooter":"_3-RoD"};